module.exports = __webpack_public_path__ + "img/frame (50).ea22c43c.jpg";